import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Hero({ onDonateClick, onLLMClick, onVolunteerClick, onPartnerClick, onLearnClick }) {
    console.log('Hero component mounted');
    
    useEffect(() => {
        const hero = document.querySelector('.hero');
        if (!hero) return;

        const particleCount = 30;
        const particles = [];
        
        for (let i = 0; i < particleCount; i++) {
            const particle = document.createElement('div');
            particle.className = 'hero-particle';
            particle.style.width = `${Math.random() * 10 + 5}px`;
            particle.style.height = particle.style.width;
            particle.style.left = `${Math.random() * 100}%`;
            particle.style.top = `${Math.random() * 100}%`;
            particle.style.animation = `float ${Math.random() * 6 + 3}s ease-in-out infinite`;
            particle.style.animationDelay = `${Math.random() * 5}s`;
            hero.appendChild(particle);
            particles.push(particle);
        }
        
        return () => {
            particles.forEach(p => p.remove());
        };
    }, []);

    return (
        <section data-name="hero" className="hero min-h-screen flex items-center justify-center relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-gray-900/80 via-gray-800/80 to-gray-900/80 z-0"></div>
            <div className="container mx-auto px-4 text-center relative z-10">
                <div data-name="hero-content" className="hero-content max-w-4xl mx-auto">
                    <h1 data-name="hero-title" className="text-6xl md:text-7xl font-extrabold mb-6 tracking-tight">
                        Sustainable <span className="text-gradient bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-emerald-600">Computing</span> Revolution
                    </h1>
                    <p data-name="hero-subtitle" className="hero-subtitle mb-10 text-xl md:text-2xl leading-relaxed text-gray-300 max-w-3xl mx-auto">
                        Bridging the digital divide by providing affordable computing power to underfunded institutions worldwide, powered by renewable energy and recycled hardware.
                    </p>
                    <div data-name="hero-cta" className="flex flex-wrap gap-4 justify-center">
                        <Link to="/donate" className="btn btn-primary transform hover:-translate-y-1 hover:shadow-xl text-lg px-8 py-4">
                            Donate Hardware
                            <i className="fas fa-arrow-right ml-2"></i>
                        </Link>
                        <Link to="/llm" className="btn btn-secondary transform hover:-translate-y-1 hover:shadow-xl text-lg px-8 py-4">
                            Sequoia A.I.
                            <i className="fas fa-leaf ml-2"></i>
                        </Link>
                        <Link to="/volunteer" className="btn btn-secondary transform hover:-translate-y-1 hover:shadow-xl text-lg px-8 py-4">
                            Volunteer With Us
                        </Link>
                        <Link to="/partner" className="btn btn-secondary transform hover:-translate-y-1 hover:shadow-xl text-lg px-8 py-4">
                            Partner With Us
                        </Link>
                    </div>
                    <div className="mt-6">
                        <Link to="/mission" className="text-white/80 hover:text-white transition-colors duration-300 flex items-center mx-auto">
                            Learn More About Us
                            <i className="fas fa-chevron-right ml-2 text-sm"></i>
                        </Link>
                    </div>
                </div>
            </div>
            
            {/* Animated background elements */}
            <div className="absolute inset-0 z-0">
                <div className="circuit-grid"></div>
            </div>
            
            {/* Hero wave divider */}
            <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none">
                <svg className="relative block w-full h-24" data-name="hero-wave" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120">
                    <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="fill-gray-800"></path>
                    <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" className="fill-gray-800"></path>
                    <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" className="fill-gray-800"></path>
                </svg>
            </div>
        </section>
    );
}

export default Hero;
